import {
    ADD_FEE_MARKUP_SUCCESS,
    ADD_FEE_MARKUP_FAILED,
    RESET_ADD_FEE_MARKUP,
    LOADING_ADD_FEE_MARKUP,
    NETWORK_ERROR_ADD_FEE_MARKUP,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddFeeMarkup = () => {
    return { type: RESET_ADD_FEE_MARKUP };
};

const addFeeMarkup =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADD_FEE_MARKUP });
        await partnerServices
            .post("addMarkupList", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        dispatch(addFeeMarkupSuccess(res.data));
                        break;
                    default:
                        dispatch(addFeeMarkupFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADD_FEE_MARKUP,
                    payload: err,
                });
            });
    };

function addFeeMarkupSuccess(data) {
    return {
        type: ADD_FEE_MARKUP_SUCCESS,
        payload: data,
    };
}

function addFeeMarkupFailed(data) {
    return {
        type: ADD_FEE_MARKUP_FAILED,
        payload: data,
    };
}

export {
    resetAddFeeMarkup,
    addFeeMarkup,
};